// ACTION TYPES
const name = 'params';
export const actionTypes = {
  SET_WTREGION: `${name}:set_wtregion`,
  SET_DIVISION: `${name}:set_divisionm`,
  SET_LANG: `${name}:set_lang`,
  SET_ASSETCLASS: `${name}:set_assetclass`,
  SET_FUNDSTRUCT: `${name}:set_fundstruct`,
  SET_LEVERAGE: `${name}:set_leverage`,
  SET_FP: `${name}:set_fp`,
};

// ACTIONS

export function setWTRegion(param) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_WTREGION, value: param });
  };
}
export function setDivision(param) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_DIVISION, value: param });
  };
}
export function setLang(param) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_LANG, value: param });
  };
}
export function setTier1CatOptions(param) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_TIER1CAT, value: param });
  };
}
export function setLeverage(param) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_LEVERAGE, value: param });
  };
}
export function setFP(param) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_FP, value: param });
  };
}




// WEBPACK FOOTER //
// ./src/actions/params.js